import { render, staticRenderFns } from "./discussion-form.vue?vue&type=template&id=3313e6ea&"
import script from "./discussion-form.vue?vue&type=script&lang=js&"
export * from "./discussion-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports